import { render } from "./FiebreDeCanto.vue?vue&type=template&id=0f3cc87c&scoped=true"
import script from "./FiebreDeCanto.vue?vue&type=script&lang=js"
export * from "./FiebreDeCanto.vue?vue&type=script&lang=js"

import "./FiebreDeCanto.vue?vue&type=style&index=0&id=0f3cc87c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f3cc87c"]])

export default __exports__